<script setup lang="ts">
import { useStorage } from '@vueuse/core'

const version = useStorage<string | null>('version', null)
const authStore = useAuthStore()

onMounted(() => {
  const currentVersion = import.meta.env.VITE_VERSION
  if (currentVersion !== version.value) {
    authStore.logout()
  }
  version.value = currentVersion
})
</script>

<template>
  <div class="bg-background h-screen">
    <RouterView v-slot="{ Component }">
      <Transition name="fade" mode="out-in">
        <component :is="Component" />
      </Transition>
    </RouterView>
  </div>
</template>
